export const siteBrand = {
  name: '深瞳爆料',
  fullName: '深瞳爆料官网',
  slogan: '让沉默的真相被听见',
  domain: 'shentong-baoliao.com',
  intro:
    '深瞳爆料是一个以信源保护为优先的调查线索汇集平台。我们把来自公众的一手信息整理、核实并推动其进入公共视野，同时为机构媒体、研究者与公众提供清晰可信的官方联络渠道。',
  email: 'contact@shentong-baoliao.com',
};

export const siteNav = [
  { label: '首页', to: '/' },
  { label: '联系方式', to: '/contact' },
  { label: '商务合作', to: '/cooperation' },
  { label: '关于我们', to: '/about' },
];

export const homeStats = [
  { value: '12,480', suffix: '+', label: '累计接收有效线索' },
  { value: '386', suffix: ' 期', label: '已公开追踪议题' },
  { value: '18', suffix: ' 小时', label: '平均首次响应时间' },
  { value: '0', suffix: ' 次', label: '公开信源泄露事件' },
];

export const quickChannels = [
  {
    icon: 'ri-mail-lock-line',
    title: '加密投稿邮箱',
    value: 'xiansuo@shentong-baoliao.com',
    desc: '支持 PGP 公钥加密，7×24 小时接收线索，邮件内容仅限线索组查阅。',
    tag: '推荐',
  },
  {
    icon: 'ri-telegram-line',
    title: '即时私密联络',
    value: 'Telegram @shentong_tips',
    desc: '适合需要连续沟通的知情人，支持阅后即焚会话与加密文件传输。',
    tag: '实时',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '匿名提交表单',
    value: '无需注册 · 可留空身份',
    desc: '浏览器直接提交，不要求填写真实姓名与联系方式，适合一次性线索。',
    tag: '匿名',
  },
];

export const contactChannels = [
  {
    icon: 'ri-mail-lock-line',
    title: '线索投稿邮箱',
    value: 'xiansuo@shentong-baoliao.com',
    desc: '接收文字、图片、录音、文档等各类线索材料，支持加密附件。',
    scene: '适用于：掌握一手信息、需要安全提交证据的知情人',
    response: '24 小时内首次查看',
    highlight: true,
  },
  {
    icon: 'ri-links-line',
    title: '商务合作邮箱',
    value: 'business@shentong-baoliao.com',
    desc: '接收转载授权、联合调查、内容共建、数据与研究合作等商务事项。',
    scene: '适用于：机构媒体、内容平台、品牌与学术机构',
    response: '2 个工作日内回复',
    highlight: false,
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '一般咨询邮箱',
    value: 'contact@shentong-baoliao.com',
    desc: '处理内容纠错、账号核实、隐私投诉与使用咨询等日常事务。',
    scene: '适用于：读者反馈、内容更正、官方账号真伪核实',
    response: '3 个工作日内回复',
    highlight: false,
  },
  {
    icon: 'ri-telegram-line',
    title: '即时通讯通道',
    value: 'Telegram @shentong_tips',
    desc: '为愿意持续配合核实的知情人提供端到端加密的即时沟通方式。',
    scene: '适用于：需要补充材料、反复沟通的深度线索',
    response: '工作时段即时响应',
    highlight: false,
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '匿名线索表单',
    value: '站内提交 · 不记录身份',
    desc: '不采集浏览器指纹与真实 IP，可完全匿名地投递一条线索。',
    scene: '适用于：暂时不愿暴露身份、只想传递信息的用户',
    response: '48 小时内评估',
    highlight: false,
  },
  {
    icon: 'ri-scales-3-line',
    title: '法务与合规事务',
    value: 'legal@shentong-baoliao.com',
    desc: '接收律师函、权利通知、侵权申诉与数据合规相关正式函件。',
    scene: '适用于：法律事务、权利主张与合规问询',
    response: '1 个工作日内确认收悉',
    highlight: false,
  },
];

export const officialAccounts = [
  { icon: 'ri-wechat-line', name: '微信公众号', handle: '深瞳爆料（ID：shentong_baoliao）', desc: '每周发布一期追踪议题整理与更正公告' },
  { icon: 'ri-weibo-line', name: '新浪微博', handle: '@深瞳爆料', desc: '议题进展快讯与公开征集入口' },
  { icon: 'ri-twitter-x-line', name: 'X（Twitter）', handle: '@shentong_expose', desc: '面向海外读者的英文简报与线索征集' },
  { icon: 'ri-bilibili-line', name: '哔哩哔哩', handle: '深瞳爆料', desc: '调查过程记录与核查方法科普' },
  { icon: 'ri-tiktok-line', name: '抖音', handle: '深瞳爆料', desc: '一分钟议题速览与线索征集提醒' },
  { icon: 'ri-book-marked-line', name: '小红书', handle: '深瞳爆料', desc: '选题预告与读者互动问答' },
];

export const submitSteps = [
  {
    step: '01',
    icon: 'ri-radar-line',
    title: '选择一条安全通道',
    desc: '根据自身情况选择加密邮箱、即时通讯或匿名表单，通道之间互不关联，可任选其一。',
  },
  {
    step: '02',
    icon: 'ri-article-line',
    title: '描述线索的关键要素',
    desc: '尽量说明时间、地点、涉及主体与你能提供的第一手依据，不必写成完整文章。',
  },
  {
    step: '03',
    icon: 'ri-file-shield-2-line',
    title: '提交可验证的材料',
    desc: '照片、录音、合同、票据、聊天记录等都可以，原始文件比转述更有核实价值。',
  },
  {
    step: '04',
    icon: 'ri-user-voice-line',
    title: '配合编辑回访核实',
    desc: '如需要补充信息，编辑会通过你留下的方式联系；你也可以随时中止沟通。',
  },
];

export const homeFaqs = [
  {
    q: '提交爆料后，我的身份信息会被公开吗？',
    a: '不会。平台默认不采集、不记录、不公开任何可识别信源身份的信息。你可以完全匿名提交，编辑团队仅在核实线索本身时使用你主动提供的材料，且材料会进行去标识化处理后再进入核查流程。',
  },
  {
    q: '加密投稿邮箱真的加密吗？需要我做什么？',
    a: '投稿邮箱支持 PGP 公钥加密。你可以在官方账号获取公钥指纹，用任意 PGP 工具加密邮件正文与附件后发送。若你不熟悉加密工具，也可以在邮件中说明，我们会提供一份逐步操作指引。',
  },
  {
    q: '平台接受哪些类型的线索材料？',
    a: '文字说明、照片、录音、视频、合同、票据、审批文件、聊天记录截图等都可以。我们更看重原始文件而非二次转述，请在安全的前提下尽量保留文件原始格式与时间信息。',
  },
  {
    q: '提交之后多久会收到回复？',
    a: '线索邮箱通常在 24 小时内完成首次查看，72 小时内给出是否进入核查流程的初步判断。由于线索数量较多，未进入核查流程的投稿可能不会逐一回复，但所有材料都会按保密规范处理。',
  },
  {
    q: '向平台提供线索需要付费吗？会产生费用吗？',
    a: '完全不需要。投稿、咨询、账号核实、商务洽谈均不收取任何费用。任何以“深瞳爆料”名义索要钱财、保证金或所谓“曝光费”的行为均与平台无关，请通过本页公布的邮箱与我们核实。',
  },
  {
    q: '如果我提供的线索后来被证明不准确怎么办？',
    a: '我们会在核查阶段与你确认细节；若公开内容出现事实偏差，平台设有更正机制，会在同一议题下发布更正说明。我们鼓励信源主动补充信息，而不是担心说错而沉默。',
  },
];

export const contactFaqs = [
  {
    q: '如何确认自己联系的是官方渠道？',
    a: '平台的官方邮箱域名统一为 shentong-baoliao.com，官方社交账号均在本页“官方账号”区域完整列出。若遇到其他域名或未列出的账号，请先发邮件到一般咨询邮箱核实，切勿在陌生页面填写身份信息或支付任何费用。',
  },
  {
    q: '商务合作一般多久能得到答复？',
    a: '商务合作邮箱在工作日 2 个工作日内回复。如涉及联合调查或数据合作，通常需要一轮线上沟通后再确定是否进入正式评估，请预留一定沟通周期。',
  },
  {
    q: '媒体转载平台内容需要授权吗？',
    a: '需要。请通过商务合作邮箱提交转载申请，说明媒体名称、栏目、使用范围与预计发布时间。涉及尚未结案的调查选题，平台可能出于信源安全考虑不予授权，敬请理解。',
  },
  {
    q: '内容有误，我该如何提出更正？',
    a: '请发送邮件至一般咨询邮箱，注明文章标题、链接与需要更正的具体内容，并附相关依据。核实后平台会在原文补充更正说明；若属于重大事实偏差，会单独发布更正公告。',
  },
];

export const highlights = [
  {
    tag: '公共事务',
    date: '2026.08.24',
    title: '某地招标项目评审记录与公示内容存在出入',
    excerpt: '多名参与者提供了同一批项目的评审文件。目前已完成初轮交叉核对，正在就其中三处评分差异向相关方求证。',
    status: '核查中',
    open: true,
    image:
      'https://readdy.ai/api/search-image?query=abstract%20dark%20pine%20green%20and%20charcoal%20document%20folders%20stacked%20with%20a%20single%20sealed%20envelope%2C%20top%20down%20editorial%20composition%20on%20warm%20paper%2C%20dramatic%20side%20light%2C%20investigative%20archive%20mood&width=900&height=640&seq=st-topic-gov-2026&orientation=landscape',
  },
  {
    tag: '商业观察',
    date: '2026.08.11',
    title: '连锁品牌门店退费条款与实际执行不一致',
    excerpt: '读者在一周内提交了 27 份来自不同城市的单据。我们已按地区归类，并邀请三位当事人参与后续核实。',
    status: '已公开',
    open: true,
    image:
      'https://readdy.ai/api/search-image?query=abstract%20minimal%20scene%20of%20scattered%20paper%20receipts%20and%20a%20magnifying%20glass%20on%20a%20warm%20cream%20desk%2C%20soft%20amber%20lighting%2C%20editorial%20still%20life%2C%20investigative%20detail%2C%20shallow%20depth%20of%20field&width=900&height=640&seq=st-topic-biz-2026&orientation=landscape',
  },
  {
    tag: '科技与数据',
    date: '2026.07.29',
    title: '应用权限申请范围与隐私说明存在偏差',
    excerpt: '技术方向的读者提供了版本对比与权限日志。议题已进入技术复核阶段，欢迎补充不同版本的安装包信息。',
    status: '技术复核',
    open: true,
    image:
      'https://readdy.ai/api/search-image?query=abstract%20macro%20of%20a%20black%20circuit%20board%20fragment%20with%20warm%20amber%20highlights%20on%20dark%20charcoal%20background%2C%20editorial%20technology%20still%20life%2C%20high%20contrast%2C%20fine%20texture&width=900&height=640&seq=st-topic-tech-2026&orientation=landscape',
  },
  {
    tag: '城市与民生',
    date: '2026.07.15',
    title: '老旧小区加装设施施工进度与承诺不符',
    excerpt: '来自同一片区六个小区的读者提供了施工告示与现场照片，我们正在比对公示时间与实际开工时间。',
    status: '征集线索',
    open: true,
    image:
      'https://readdy.ai/api/search-image?query=abstract%20urban%20night%20street%20corner%20with%20blurred%20amber%20streetlight%20and%20an%20empty%20bench%2C%20grainy%20cinematic%20editorial%20mood%2C%20muted%20warm%20tones%2C%20no%20people&width=900&height=640&seq=st-topic-city-2026&orientation=landscape',
  },
];

export const cooperationTypes = [
  {
    icon: 'ri-newspaper-line',
    title: '内容转载授权',
    desc: '面向正规媒体与内容平台，提供已结案议题的转载授权、原文配图使用规范与更正同步机制。',
    points: ['授权范围与期限书面确认', '配图需保留原始水印', '后续更正需同步更新'],
  },
  {
    icon: 'ri-search-eye-line',
    title: '联合调查协作',
    desc: '与具备采访与法务能力的机构媒体共建选题，平台承担线索汇集与数据整理，合作方承担实地采访。',
    points: ['双方共同署名', '核查标准事先约定', '信源信息不对外共享'],
  },
  {
    icon: 'ri-database-2-line',
    title: '数据与研究合作',
    desc: '面向高校与研究机构，在脱敏与合规前提下提供公开议题的结构化数据集，用于公共政策研究。',
    points: ['数据脱敏后交付', '限定研究用途', '成果需注明数据来源'],
  },
  {
    icon: 'ri-lightbulb-line',
    title: '品牌与内容共建',
    desc: '与关注公共议题的品牌合作开展公众教育类内容，合作内容需明确标注商业属性，不得影响议题独立性。',
    points: ['明确标注合作属性', '不接受影响结论的诉求', '内容全程可追溯'],
  },
  {
    icon: 'ri-code-s-slash-line',
    title: '安全技术协作',
    desc: '与安全研究团队协作改进加密收信、匿名提交与信源保护工具，共同提升线索通道的安全水位。',
    points: ['工具代码可审计', '不接受后门需求', '漏洞按负责任制披露'],
  },
];

export const cooperationSteps = [
  { step: '01', title: '提交合作意向', desc: '通过商务合作表单或邮箱说明机构背景、合作类型与期望目标。' },
  { step: '02', title: '初步线上沟通', desc: '商务团队在 2 个工作日内安排线上会议，明确需求与可行性。' },
  { step: '03', title: '签署合作约定', desc: '就范围、署名、保密与更正机制形成书面约定后启动执行。' },
  { step: '04', title: '执行与复盘', desc: '按约定节点推进，结束后共同复盘并同步可公开的成果。' },
];

export const cooperationRules = [
  '合作不影响议题独立性，平台不接受任何以撤稿、改结论为前提的合作诉求。',
  '涉及尚未结案的线索，其信源信息与合作方完全隔离，不因合作而共享。',
  '商业属性内容须在显著位置标注，避免读者误认为调查报道。',
  '合作方需遵守平台的更正机制，发现事实偏差应及时同步。',
];

export const aboutPrinciples = [
  {
    icon: 'ri-lock-2-line',
    title: '信源保护优先',
    desc: '任何一次选题判断都以不暴露信源为前提。当核实需求与信源安全冲突时，优先保护信源。',
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: '事实核查为底线',
    desc: '未完成关键事实交叉核对的议题不会公开，宁可延后，也不发布无法支撑的结论。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '不作有罪推定',
    desc: '我们公开的是可验证的事实与流程疑点，不对当事人动机与责任作未经验证的定性。',
  },
  {
    icon: 'ri-refund-2-line',
    title: '拒绝利益交换',
    desc: '不接受付费撤稿、有偿删帖与任何形式的封口条件，合作与内容决策相互独立。',
  },
  {
    icon: 'ri-error-warning-line',
    title: '公开纠错机制',
    desc: '出现事实偏差时在同一议题下发布更正说明，重大偏差单独发布更正公告。',
  },
];

export const milestones = [
  { year: '2019', title: '从一封匿名邮件开始', desc: '平台以个人维护的匿名收信邮箱起步，第一年整理并推动了 9 个小型公共议题。' },
  { year: '2021', title: '建立信源保护流程', desc: '引入 PGP 加密收信与去标识化处理规范，明确信源信息的最小知情范围。' },
  { year: '2023', title: '启动联合调查协作', desc: '与多家机构媒体建立协作机制，平台负责线索与数据，媒体负责实地采访。' },
  { year: '2025', title: '开放公开议题数据集', desc: '将已结案议题整理为脱敏数据集，向研究机构与公众开放查询。' },
];

export const testimonials = [
  {
    quote: '线索整理得很细，时间线、材料来源和疑点都标得清清楚楚，我们接手后直接进入了采访阶段。',
    name: '某机构媒体调查组编辑',
    meta: '联合调查合作方',
  },
  {
    quote: '第一次投稿的时候很担心身份问题，沟通过程里对方甚至主动减少了需要我提供的信息量，这点让人安心。',
    name: '一位不愿具名的知情人',
    meta: '线索提供者',
  },
  {
    quote: '申请数据集用于课题研究，脱敏处理和用途约定都很规范，比预期中顺畅很多。',
    name: '高校公共政策研究方向研究者',
    meta: '数据合作方',
  },
];